export default {
  modalState: state => state.modalState,
  emergeMode: state => state.emergeMode
}
